import commonEn from "../locale/common/en.json"
import commonId from "../locale/common/id.json"
import parameterEn from "../locale/main/parameter/en.json"
import userEn from "../locale/admin/user/en.json"
import userId from "../locale/admin/user/id.json"
import userInvitationEn from "../locale/admin/userInvitation/en.json"
import userInvitationId from "../locale/admin/userInvitation/id.json"
import userSendInvitationEn from "../locale/admin/userSendInvitation/en.json"
import userSendInvitationId from "../locale/admin/userSendInvitation/id.json"
import userDetailEn from "../locale/admin/userDetail/en.json"
import userDetailId from "../locale/admin/userDetail/id.json"
import depotId from "../locale/main/depot/id.json"
import AdditionalProofsEn from "../locale/main/additionalProofs/en.json"
import AdditionalProofsId from "../locale/main/additionalProofs/id.json"
import addressFormatConfigurationEn from "../locale/setup/addressFormatConfig/en.json"
import addressFormatConfigurationId from "../locale/setup/addressFormatConfig/id.json"
import skillSetEn from "../locale/master/skillset/en.json"
import skillSetId from "../locale/master/skillset/id.json"
import skillSetAddEn from "../locale/master/skillsetAdd/en.json"
import skillSetAddId from "../locale/master/skillsetAdd/id.json"
import skillSetEditEn from "../locale/master/skillsetEdit/en.json"
import skillSetEditId from "../locale/master/skillsetEdit/id.json"
import skillSetDetailEn from "../locale/master/skillDetail/en.json"
import skillSetDetailId from "../locale/master/skillDetail/id.json"
import vehicleListEn from "../locale/master/vehicleList/en.json"
import vehicleListId from "../locale/master/vehicleList/id.json"
import vehicleDetailEn from "../locale/master/vehicleDetail/en.json"
import vehicleDetailId from "../locale/master/vehicleDetail/id.json"
import driverId from "../locale/main/driver/id.json"
import vehicleAddEn from "../locale/master/vehicleAdd/en.json"
import vehicleAddId from "../locale/master/vehicleAdd/id.json"
import VehicleEditEn from "../locale/master/vehicleEdit/en.json"
import VehicleEditId from "../locale/master/vehicleEdit/id.json"
import DeliveryTypeListEn from "../locale/master/DeliveryTypeList/en.json"
import DeliveryTypeListId from "../locale/master/DeliveryTypeList/id.json"
import DeliveryTypeAddEn from "../locale/master/DeliveryTypeAdd/en.json"
import DeliveryTypeAddId from "../locale/master/DeliveryTypeAdd/id.json"
import DeliveryTypeEditEn from "../locale/master/DeliveryTypeEdit/en.json"
import DeliveryTypeEditId from "../locale/master/DeliveryTypeEdit/id.json"
import DeliveryTypeDetailEn from "../locale/master/DeliveryTypeDetail/en.json"
import DeliveryTypeDetailId from "../locale/master/DeliveryTypeDetail/id.json"
import PalletListEn from "../locale/master/PalletList/en.json"
import PalletListId from "../locale/master/PalletList/id.json"
import PalletAddEn from "../locale/master/PalletAdd/en.json"
import PalletAddId from "../locale/master/PalletAdd/id.json"
import PalletDetailEn from "../locale/master/PalletDetail/en.json"
import PalletDetailId from "../locale/master/PalletDetail/id.json"
import PalletEditEn from "../locale/master/PalletEdit/en.json"
import PalletEditId from "../locale/master/PalletEdit/id.json"
import DriverEn from "../locale/main/driver/en.json"
import CustomerEn from "../locale/main/customer/en.json"
import CustomerId from "../locale/main/customer/id.json"
import UomListEn from "../locale/setup/UnitOfMeasurementList/en.json"
import UomListId from "../locale/setup/UnitOfMeasurementList/id.json"
import completionEn from "../locale/login/completion/en.json"
import completionId from "../locale/login/completion/id.json"
import deliveryAssociateEn from "../locale/master/DeliveryAssociate/en.json";
import deliveryAssociateId from "../locale/master/DeliveryAssociate/id.json";
import tripPlanningEn from '../locale/order/routes/trip-planning/en.json';
import tripPlanningId from '../locale/order/routes/trip-planning/id.json';
import dataGroupEn from '../locale/admin/data-group/en.json';
import dataGroupId from '../locale/admin/data-group/id.json';
import temperatureCategoryEn from '../locale/setup/temperature-category/en.json';
import temperatureCategoryId from '../locale/setup/temperature-category/id.json';
import depotEn from "../locale/main/depot/en.json";
import companyProfileEn from "../locale/setup/company-profile/en.json";
import companyProfileId from "../locale/setup/company-profile/id.json";

export const resourceLanguage = {
  en: {
    COMMON: commonEn,
    PARAMETER: parameterEn,
    USER: userEn,
    USER_INVITATION: userInvitationEn,
    USER_SEND_INVITATION: userSendInvitationEn,
    USER_DETAIL: userDetailEn,
    ADDRESS_FORMAT_CONFIG: addressFormatConfigurationEn,
    SKILLSET: skillSetEn,
    SKILLSET_ADD: skillSetAddEn,
    SKILLSET_EDIT: skillSetEditEn,
    SKILLSET_DETAIL: skillSetDetailEn,
    VEHICLE_LIST: vehicleListEn,
    VEHICLE_ADD: vehicleAddEn,
    VEHICLE_DETAIL: vehicleDetailEn,
    VEHICLE_EDIT: VehicleEditEn,
    DELIVERY_TYPE_LIST: DeliveryTypeListEn,
    DELIVERY_TYPE_ADD: DeliveryTypeAddEn,
    DELIVERY_TYPE_EDIT: DeliveryTypeEditEn,
    DELIVERY_TYPE_DETAIL: DeliveryTypeDetailEn,
    PALLET_LIST: PalletListEn,
    PALLET_ADD: PalletAddEn,
    PALLET_DETAIL: PalletDetailEn,
    PALLET_EDIT: PalletEditEn,
    DRIVER: DriverEn,
    ADDITIONAL_PROOFS: AdditionalProofsEn,
    CUSTOMER: CustomerEn,
    UOM_LIST: UomListEn,
    DATA_GROUP: dataGroupEn,
    LOGIN_COMPLETION: completionEn,
    DELIVERY_ASSOCIATE: deliveryAssociateEn,
    TRIP_PLANNING: tripPlanningEn,
    TEMPERATURE_CATEGORY: temperatureCategoryEn,
    DEPOT: depotEn,
    COMPANY_PROFILE: companyProfileEn
  },
  id: {
    COMMON: commonId,
    // PARAMETER: parameterId,
    USER: userId,
    USER_INVITATION: userInvitationId,
    USER_SEND_INVITATION: userSendInvitationId,
    USER_DETAIL: userDetailId,
    ADDRESS_FORMAT_CONFIG: addressFormatConfigurationId,
    SKILLSET: skillSetId,
    SKILLSET_ADD: skillSetAddId,
    SKILLSET_EDIT: skillSetEditId,
    SKILLSET_DETAIL: skillSetDetailId,
    VEHICLE_LIST: vehicleListId,
    VEHICLE_ADD: vehicleAddId,
    VEHICLE_DETAIL: vehicleDetailId,
    VEHICLE_EDIT: VehicleEditId,
    DEPOT: depotId,
    ADDITIONAL_PROOFS: AdditionalProofsId,
    DRIVER: driverId,
    DELIVERY_TYPE_LIST: DeliveryTypeListId,
    DELIVERY_TYPE_ADD: DeliveryTypeAddId,
    DELIVERY_TYPE_EDIT: DeliveryTypeEditId,
    DELIVERY_TYPE_DETAIL: DeliveryTypeDetailId,
    PALLET_LIST: PalletListId,
    PALLET_ADD: PalletAddId,
    PALLET_DETAIL: PalletDetailId,
    PALLET_EDIT: PalletEditId,
    CUSTOMER: CustomerId,
    UOM_LIST: UomListId,
    DATA_GROUP: dataGroupId,
    LOGIN_COMPLETION: completionId,
    DELIVERY_ASSOCIATE: deliveryAssociateId,
    TRIP_PLANNING: tripPlanningId,
    TEMPERATURE_CATEGORY: temperatureCategoryId,
    COMPANY_PROFILE: companyProfileId
  },
};